import { useParams } from "react-router-dom";

import useGetMultiple from "../../../CustomHooks/useAxios/useGetMultiple";
import DialogBox from "../../../components/UI/DialogBox";
import { handleErrMessage } from "../../../functions/handleErrMessage";
import spin from "../../../assets/icons/spin.png";
import { UPDATE_USER_ADMINS_SETUP, UPDATE_USER_ADMINS } from "../apiEndpoints";
import { GET_USER } from "../../../api/allApi_List";
import MainPageLayout from "../../../layout/MainPageLayout";
import UpdateAdminsForm from "../form/UpdateAdminsForm";
import usePostData from "../../../CustomHooks/useAxios/usePostData";

const UpdateUserAdminsPage = () => {
  const { id } = useParams();
  const { data, isLoaded, error } = useGetMultiple([
    GET_USER + id,
    UPDATE_USER_ADMINS_SETUP,
  ]);
  const { executePost, loading, formError, setFormError, successResponse } =
    usePostData();

  // execute post api
  const sendData = async (formValues, updateStateOnResponse) => {
    executePost(formValues, UPDATE_USER_ADMINS, updateStateOnResponse);
  };
  return (
    <MainPageLayout headerConfig={{ title: "Update User Admins" }}>
      {isLoaded && !error ? (
        <UpdateAdminsForm
          userData={data[0]}
          userSetup={data[1]}
          sendData={sendData}
          loading={loading}
          successResponse={successResponse}
        />
      ) : error ? (
        <DialogBox
          title="Error"
          message={handleErrMessage(error)}
          isErrorHandleButtons={true}
        />
      ) : (
        <DialogBox message="Loading your data" animateIcon={spin} />
      )}
      {formError && (
        <DialogBox
          title="Error"
          btnText="Ok"
          message={handleErrMessage(formError)}
          closeAction={() => setFormError("")}
        />
      )}
    </MainPageLayout>
  );
};
export default UpdateUserAdminsPage;
